if (!customElements.get("testimonials-slider")) {
  class TestimonialsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector(".swiper"), {
        slidesPerView: 1.15,
        spaceBetween: 15,
        navigation: {
          prevEl: this.querySelector(".swiper-button-prev"),
          nextEl: this.querySelector(".swiper-button-next"),
        },
        scrollbar: {
          el: this.querySelector(".swiper-scrollbar"),
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          type: "fraction",
        },
        breakpoints: {
          990: {
            slidesPerView: 3.742,
            slidesOffsetAfter: 70,
          },
          1440: {
            slidesPerView: 3.742,
            slidesOffsetAfter: 60,
          },
          1640: {
            slidesPerView: 3.742,
            slidesOffsetAfter: 55,
          },
        },
      });
    }
  }
  customElements.define("testimonials-slider", TestimonialsSlider);
}
